<template>
  <layout>
    <div slot="content">
      <i-card :title="isEdit ? '编辑合同模板' : '新增合同模板'">
        <el-button slot="right-menu" type="warning" size="small" :loading="loadingDefault" @click="fillDefaultTemplate">填入默认模板</el-button>
        <div slot="content">
          <el-row :gutter="20">
            <!-- 左侧：表单 + 编辑器 -->
            <el-col :span="18">
              <el-form :model="form" label-width="100px" size="small">
                <el-form-item label="模板名称" required>
                  <el-input v-model="form.name" placeholder="请输入合同模板名称" />
                </el-form-item>
                <el-form-item label="备注">
                  <el-input v-model="form.remark" placeholder="备注说明（选填）" />
                </el-form-item>
                <el-form-item label="状态">
                  <el-radio-group v-model="form.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="合同内容" required>
                  <el-alert
                    title="提示：点击右侧变量按钮可将变量插入到编辑器光标位置，渲染时会自动替换为订单真实数据。"
                    type="info"
                    :closable="false"
                    show-icon
                    style="margin-bottom: 8px"
                  />
                  <i-editor-pro
                    ref="editorPro"
                    v-model="form.content"
                    :min-height="480"
                    placeholder="请在此编写合同模板内容，可插入右侧变量..."
                  />
                </el-form-item>
              </el-form>

              <div style="text-align: center; margin-top: 24px">
                <el-button @click="goBack">取 消</el-button>
                <el-button type="primary" :loading="saving" @click="handleSave">保 存</el-button>
              </div>
            </el-col>

            <!-- 右侧：变量面板 -->
            <el-col :span="6">
              <div class="variable-panel" v-loading="loadingVars">
                <div class="panel-title">
                  <i class="el-icon-magic-stick"></i> 可用变量
                  <span class="panel-tip">（点击插入到编辑器）</span>
                </div>
                <div class="var-list">
                  <div
                    v-for="v in variables"
                    :key="v.key"
                    class="var-item"
                    @click="insertVariable(v)"
                  >
                    <div class="var-key">{{ varTag(v.key) }}</div>
                    <div class="var-label">{{ v.label }}</div>
                    <div class="var-desc">{{ v.desc }}</div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
import layout from '@/components/layout'
import iCard from '@/components/i-card'
import iEditorPro from '@/components/i-editor-pro'

export default {
  name: 'contract-form',
  components: { layout, iCard, iEditorPro },
  data() {
    return {
      isEdit: false,
      saving: false,
      loadingVars: false,
      loadingDefault: false,
      variables: [],
      form: {
        id: null,
        name: '',
        remark: '',
        status: 1,
        content: '',
      },
    }
  },
  methods: {
    insertVariable(variable) {
      const tag = `{{${variable.key}}}`
      const html = `<span style="color:#e6700d;font-weight:bold;background:#fff3e0;padding:0 3px;border-radius:3px">${tag}</span>`
      this.$refs.editorPro.insertHtml(html)
      this.$message.success(`已插入：${tag}`)
    },
    loadVariables() {
      this.loadingVars = true
      this.$http.request('contractVariableList').then(res => {
        this.loadingVars = false
        if (res && res.data) {
          this.variables = res.data
        }
      }).catch(() => {
        this.loadingVars = false
      })
    },
    loadTemplate(id) {
      this.$http.request('getContractTemplate', { id }).then(res => {
        if (res && res.data) {
          const t = res.data
          this.form = {
            id: t.id,
            name: t.name,
            remark: t.remark || '',
            status: t.status,
            content: t.content || '',
          }
        }
      })
    },
    handleSave() {
      if (!this.form.name.trim()) {
        this.$message.error('请填写模板名称')
        return
      }
      // 从编辑器获取最新内容
      const content = this.$refs.editorPro ? this.$refs.editorPro.getHtml() : this.form.content
      if (!content || content === '<p><br></p>') {
        this.$message.error('请填写合同内容')
        return
      }
      this.form.content = content
      this.saving = true

      const api = this.isEdit ? 'editContractTemplate' : 'addContractTemplate'
      this.$http.request(api, this.form).then(res => {
        this.saving = false
        if (res && res.status === 'success') {
          this.$message.success(this.isEdit ? '编辑成功' : '添加成功')
          this.goBack()
        }
      }).catch(() => {
        this.saving = false
      })
    },
    fillDefaultTemplate() {
      this.$confirm('填入默认模板将覆盖当前编辑器内容，是否继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确认填入',
        cancelButtonText: '取消',
      }).then(() => {
        this.loadingDefault = true
        this.$http.request('getContractDefaultTemplate').then(res => {
          this.loadingDefault = false
          if (res && res.data && res.data.content) {
            this.$refs.editorPro.setHtml(res.data.content)
            this.$message.success('已填入默认合同模板')
          }
        }).catch(() => {
          this.loadingDefault = false
          this.$message.error('获取默认模板失败')
        })
      }).catch(() => {})
    },
    varTag(key) {
      return '{{' + key + '}}'
    },
    goBack() {
      this.$router.push({ name: 'contract.template_list' })
    },
  },
  mounted() {
    this.loadVariables()
    const id = this.$route.query.id
    if (id) {
      this.isEdit = true
      this.loadTemplate(id)
    }
  },
}
</script>

<style scoped>
.variable-panel {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  background: #fafafa;
  padding: 12px;
  position: sticky;
  top: 20px;
}

.panel-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.panel-tip {
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}

.var-list {
  max-height: 580px;
  overflow-y: auto;
}

.var-item {
  padding: 8px 10px;
  margin-bottom: 6px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.var-item:hover {
  border-color: #409eff;
  background: #ecf5ff;
}

.var-key {
  font-size: 12px;
  font-family: monospace;
  color: #e6700d;
  font-weight: bold;
  margin-bottom: 2px;
}

.var-label {
  font-size: 13px;
  color: #303133;
}

.var-desc {
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/contract/contract-form.vue